import type { Settings } from "../character";
import { getSetting, setSetting } from "../character";

export type Theme = Settings["theme"];
export const THEMES: readonly Theme[] = ["system", "light", "dark"];
export const THEME_LABELS: Record<Theme, string> = { system: "System", light: "Light", dark: "Dark" };

/** Stamp the theme on the document: `data-theme` drives the palette in base.css; "system" removes it. */
export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", theme);
}

/** Read the saved theme and apply it; the setting is small and read once per page load. */
export async function loadTheme(): Promise<Theme> {
  const theme = await getSetting("theme").catch((): Theme => "system");
  applyTheme(theme);
  return theme;
}

export async function saveTheme(theme: Theme): Promise<void> {
  applyTheme(theme);
  await setSetting("theme", theme);
}
